import { AuditLog } from "./types";
import { v4 as uuidv4 } from "uuid";

// Generate random dates within the last 30 days
const getRandomDate = () => {
  const now = new Date();
  const thirtyDaysAgo = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
  const randomTime =
    thirtyDaysAgo.getTime() +
    Math.random() * (now.getTime() - thirtyDaysAgo.getTime());
  return new Date(randomTime).toISOString();
};

export const getMockAuditLogs = (): AuditLog[] => {
  return [
    {
      auditId: uuidv4(),
      userId: "1",
      userName: "John Doe",
      userEmail: "john.doe@example.com",
      timestamp: getRandomDate(),
      action: "login",
      resourceType: "system",
      ipAddress: "192.168.1.1",
      userAgent: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7)",
    },
    {
      auditId: uuidv4(),
      userId: "2",
      userName: "Jane Smith",
      userEmail: "jane.smith@example.com",
      timestamp: getRandomDate(),
      action: "create",
      resourceType: "fund",
      resourceId: "101",
      resourceName: "Growth Fund 2023",
      details: "Created new fund",
      ipAddress: "192.168.1.2",
      userAgent: "Mozilla/5.0 (Windows NT 10.0; Win64; x64)",
    },
    {
      auditId: uuidv4(),
      userId: "3",
      userName: "Alex Johnson",
      userEmail: "alex.johnson@example.com",
      timestamp: getRandomDate(),
      action: "update",
      resourceType: "client",
      resourceId: "201",
      resourceName: "Acme Corp",
      details: "Updated client contact information",
      ipAddress: "192.168.1.3",
      userAgent: "Mozilla/5.0 (iPhone; CPU iPhone OS 14_0)",
    },
    {
      auditId: uuidv4(),
      userId: "1",
      userName: "John Doe",
      userEmail: "john.doe@example.com",
      timestamp: getRandomDate(),
      action: "download",
      resourceType: "report",
      resourceId: "301",
      resourceName: "Q2 2023 Performance Report",
      ipAddress: "192.168.1.1",
      userAgent: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7)",
    },
    {
      auditId: uuidv4(),
      userId: "4",
      userName: "Sarah Wilson",
      userEmail: "sarah.wilson@example.com",
      timestamp: getRandomDate(),
      action: "view",
      resourceType: "transaction",
      resourceId: "401",
      resourceName: "Transaction #401",
      ipAddress: "192.168.1.4",
      userAgent: "Mozilla/5.0 (iPad; CPU OS 14_0)",
    },
    {
      auditId: uuidv4(),
      userId: "2",
      userName: "Jane Smith",
      userEmail: "jane.smith@example.com",
      timestamp: getRandomDate(),
      action: "delete",
      resourceType: "import",
      resourceId: "501",
      resourceName: "July Import Batch",
      details: "Deleted failed import",
      ipAddress: "192.168.1.2",
      userAgent: "Mozilla/5.0 (Windows NT 10.0; Win64; x64)",
    },
    {
      auditId: uuidv4(),
      userId: "5",
      userName: "Michael Brown",
      userEmail: "michael.brown@example.com",
      timestamp: getRandomDate(),
      action: "generate",
      resourceType: "report",
      resourceId: "302",
      resourceName: "Annual Tax Report 2023",
      ipAddress: "192.168.1.5",
      userAgent: "Mozilla/5.0 (X11; Linux x86_64)",
    },
    {
      auditId: uuidv4(),
      userId: "3",
      userName: "Alex Johnson",
      userEmail: "alex.johnson@example.com",
      timestamp: getRandomDate(),
      action: "upload",
      resourceType: "import",
      resourceId: "502",
      resourceName: "August Transactions",
      details: "Uploaded transaction CSV",
      ipAddress: "192.168.1.3",
      userAgent: "Mozilla/5.0 (iPhone; CPU iPhone OS 14_0)",
    },
    {
      auditId: uuidv4(),
      userId: "6",
      userName: "Emily Davis",
      userEmail: "emily.davis@example.com",
      timestamp: getRandomDate(),
      action: "create",
      resourceType: "user",
      resourceId: "7",
      resourceName: "Robert Taylor",
      details: "Created new user account",
      ipAddress: "192.168.1.6",
      userAgent: "Mozilla/5.0 (Windows NT 10.0; Win64; x64)",
    },
    {
      auditId: uuidv4(),
      userId: "1",
      userName: "John Doe",
      userEmail: "john.doe@example.com",
      timestamp: getRandomDate(),
      action: "update",
      resourceType: "reporting_period",
      resourceId: "601",
      resourceName: "Q3 2023",
      details: "Updated reporting period dates",
      ipAddress: "192.168.1.1",
      userAgent: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7)",
    },
  ];
};
